// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__ERZiN"};